export const toggleRow = (selected: string[], id: string): string[] =>
  selected.includes(id)
    ? selected.filter((item) => item !== id)
    : [...selected, id];

export const areAllSelected = (
  selected: string[],
  pageIds: string[],
): boolean =>
  pageIds.length > 0 && pageIds.every((id) => selected.includes(id));

export const isSomeSelected = (
  selected: string[],
  pageIds: string[],
): boolean =>
  pageIds.some((id) => selected.includes(id)) &&
  !areAllSelected(selected, pageIds);

export const toggleAllOnPage = (
  selected: string[],
  pageIds: string[],
): string[] => {
  if (pageIds.length === 0) return selected;
  if (areAllSelected(selected, pageIds)) {
    return selected.filter((id) => !pageIds.includes(id));
  }
  return Array.from(new Set([...selected, ...pageIds]));
};
